import React from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import PostLike from '../post-like';
import PostHits from '../post-hits';
import SendComment from '../send-comment';

const PostActions = ({ id, like, dislike, hits } : {id: string, like: string, dislike: string, hits: number}) => {
  return (
    <Div className={'w-full justify-between items-center mt-3'}>
      <PostLike
        id={id}
        like={like}
        dislike={dislike}
      />
      <Div className={'gap-x-2 sm:gap-x-5'}>
        <SendComment />
        <PostHits hits={hits} />
      </Div>
    </Div>
  );
};

export default PostActions;
